module.exports = __webpack_public_path__ + "img/20_87.b7a9a044.png";